// A sticky `?debug` flag for the player editor's debug affordances
// (the Copy JSON button, the `window.__PLAYER_PREF` handle).
//
// Modelled on `playerSdk.js`: the URL parameter sets the state and it is
// remembered in localStorage, so a support user turns it on once with
// `?debug` and it survives navigation within Control Center rather than
// having to re-append it to every URL. `?debug=off` clears it.
//
// This is a convenience gate, NOT a security boundary. Everything it
// reveals -- copying your own preference, a console handle on it -- is
// already yours; the flag only keeps those tools out of the normal admin
// UI until someone asks for them.

/** Where the choice is remembered, so it survives navigation in CC. */
const STORAGE_KEY = 'invintus.debug';

/** `?debug` (or `?debug=1/on/true`) enables; `?debug=off/0/false/reset` clears. */
const PARAM = 'debug';

const ON = ['', '1', 'on', 'true', 'yes'];
const OFF = ['off', '0', 'false', 'no', 'reset'];

/**
 * Whether debug affordances should show. True in a development build
 * regardless, otherwise driven by the sticky `?debug` flag.
 *
 * @returns {boolean}
 */
export function isDebugEnabled () {
    if (process.env.NODE_ENV === 'development') return true;

    try {
        const raw = new URLSearchParams(window.location.search).get(PARAM);

        if (raw !== null) {
            const value = raw.toLowerCase();
            if (OFF.indexOf(value) !== -1) {
                window.localStorage.removeItem(STORAGE_KEY);
                return false;
            }
            if (ON.indexOf(value) !== -1) {
                window.localStorage.setItem(STORAGE_KEY, '1');
                return true;
            }
            // An unrecognized value is ignored -- fall through to the
            // remembered state rather than guessing intent.
        }

        return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        // Private-mode storage or a malformed URL: treat as off.
        return false;
    }
}
